/**
 * Helpers to prepare the permissions tree returned by
 * UserManagement/GetGroupPermissions2 (id, value, checkState, data)
 * for the Perfil Opciones view (profileOptions).
 */

/**
 * Prepares a GetGroupPermissions2 tree to be rendered by webix components.
 * - Maps the checkState of every node to the markCheckbox flag expected by
 *   the permissions grouplist (dataview) template:
 *   'On' -> checked | 'Off' -> unchecked | 'Blocked' -> checked and disabled.
 * - Replaces the node id with a unique internal id (webix requires unique ids,
 *   but the backend can repeat the same id in a MENU and its SUBMENU copy).
 *   The original backend id is preserved in permId (used when saving).
 * @param {Array} nodes - Permissions tree to mark (mutated in place).
 * @returns {Array} The same tree with markCheckbox flags and unique ids applied.
 */
export function markPermissionsTree(nodes) {
    var counter = 0; // Counter for the unique internal ids
    const mark = (items) => {
        items.forEach((node) => {
            node.permId = node.id; // Preserve the backend permission id (can repeat across the tree)
            counter = counter + 1;
            node.id = 'p' + counter + '_'; // Unique internal id for webix (the '_' avoids substring collisions in the search filter)
            node.markCheckbox = node.checkState === 'On' || node.checkState === 'Blocked' ? 1 : 0; // Map checkState to checkbox flag
            if (node.data != undefined) {
                mark(node.data); // Mark nested permissions
            }
        });
    };
    mark(nodes);
    return nodes;
}

/**
 * Flattens the permissions tree into a plain list (used by the
 * "Buscar Permiso" combo).
 * @param {Array} nodes - Permissions tree.
 * @returns {Array} Flat list with every node of the tree.
 */
export function flattenPermissions(nodes) {
    const list = [];
    const walk = (items) => {
        items.forEach((item) => {
            list.push(item);
            if (item.data != undefined) {
                walk(item.data); // Include nested permissions
            }
        });
    };
    walk(nodes);
    return list;
}

// FILE DOCUMENTED
